"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BASE = exports.STREAMID_CODEC = void 0;
exports.STREAMID_CODEC = 206;
exports.DEFAULT_BASE = 'base36';
//# sourceMappingURL=constants.js.map